(() => {
  if (window.__cImageTextOverlayInitialized) return;
  window.__cImageTextOverlayInitialized = true;

  const init = () => {
    const sections = Array.from(document.querySelectorAll('.c_image-text-overlay'));
    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    const maxShift = 25;
    const lerp = 0.10;

    sections.forEach((section) => {
      const picture = section.querySelector('.c_image-text-overlay__media');
      if (!picture || !picture.querySelector('img')) return;

      const item = {
        frameEl: section,
        picture,
        current: 0,
        top: 0,
        height: 0,
        rafId: null,
      };

      function calcMetrics() {
        const rect = item.frameEl.getBoundingClientRect();
        item.top = rect.top + window.scrollY;
        item.height = rect.height;
      }

      function getTarget() {
        const vh = window.innerHeight || 1;
        const center = (item.top - window.scrollY) + item.height / 2;
        const norm = (center / vh - 0.5) * 2;
        return Math.max(-1, Math.min(1, norm)) * maxShift;
      }

      function tick() {
        const target = getTarget();
        item.current += (target - item.current) * lerp;
        if (Math.abs(target - item.current) < 0.1) item.current = target;
        item.picture.style.transform = `translate3d(0, ${item.current.toFixed(2)}px, 0)`;
        item.rafId = requestAnimationFrame(tick);
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!item.rafId) item.rafId = requestAnimationFrame(tick);
          } else {
            if (item.rafId) { cancelAnimationFrame(item.rafId); item.rafId = null; }
          }
        });
      }, { threshold: 0, rootMargin: '100px 0px' });

      observer.observe(section);

      window.addEventListener('resize', calcMetrics);
      window.addEventListener('load', calcMetrics);
      calcMetrics();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
